const excludedTags = ["TD", "TR", "TBODY", "THEAD", "TFOOT"];

export default function getRelativePosition(element1: HTMLElement, element2: HTMLElement) {
    let position = {
        left: element1.offsetLeft,
        top: element1.offsetTop
    };

    while (element1.parentElement && element1.parentElement !== element2.parentElement && element1.parentElement !== document.body) {
        if (!excludedTags.includes(element1.parentElement.tagName)) {
            position.left += element1.parentElement.offsetLeft - element1.parentElement.scrollLeft;
            position.top += element1.parentElement.offsetTop - element1.parentElement.scrollTop;
        }

        element1 = element1.parentElement;
    }

    return position;
}